import { useId } from "react";
import { useHudStore } from "../store/hudStore";
import { DOMAINS, heatColor, titleCase } from "../data/seed";
import { Badge, Button } from "../design-system/components";
import type { Quest } from "../types";
import "./questRows.css";

// Goal and domain lists share the board's completion, heading, and action
// layout, with only the metadata relevant to the surrounding page.
export default function CompactRow({ quest: q, showDomainChip }: { quest: Quest; showDomainChip: boolean }) {
  const st = useHudStore();
  const done = !!st.done[q.id];
  const d = DOMAINS.find((x) => x.name === q.domain);
  const color = heatColor(d ? d.health : 60);
  const titleId = `compact-quest-${useId()}`;

  return (
    <article className={`ds-quest hud-quest hud-quest--compact${showDomainChip ? "" : " hud-quest--without-metadata"}${done ? " ds-quest--done" : ""}`} aria-labelledby={titleId}>
      <button type="button" className="ds-quest-complete ds-focusable" onClick={() => done ? st.undo(q.id) : st.complete(q.id)} aria-label={`${done ? "Reopen" : "Complete"} ${q.title}`} aria-pressed={done}>
        <span className="ds-quest-check"><span className="ds-icon" aria-hidden="true"><i className="fa-solid fa-check" /></span></span>
      </button>
      <div className="ds-quest-heading">
        <h3 id={titleId} className="ds-quest-title"><button type="button" className="ds-quest-open ds-focusable" onClick={() => st.openQuest(q.id)} title="Open quest details">{q.title}</button></h3>
        <Badge>{titleCase(q.type)}</Badge>
      </div>
      {showDomainChip && <div className="ds-quest-metadata hud-quest-metadata">
        <button type="button" className="hud-quest-meta-link ds-focusable" onClick={() => st.openDomain(q.domain)}>
          <span className="hud-quest-domain-dot" style={{ background: color }} aria-hidden="true" />
          <span>{q.domain}</span>
        </button>
      </div>}
      <div className="ds-quest-footer">
        <div className="ds-quest-actions"><Button size="compact" icon="fa-solid fa-stopwatch" onClick={() => st.focus(q.id)} aria-label={`Start focus on ${q.title}`}>Focus</Button></div>
        <span className="ds-quest-xp">+{q.xp} XP</span>
      </div>
    </article>
  );
}
